export const generalPt = {
  strTarefa: 'Tarefa',
  strInsumo: 'Insumo',
  strQueProcura: 'O que você procura?',
  strCod: 'código',
  strMoeda: 'moeda',
  strContracts: 'Contratos a pagar',
  strTotal: 'Total',
  strContratado: 'Contratado',
  strPago: 'Pago',
  strLiberado: 'Liberado',
  strSaldo: 'Saldo',
  strSaldoAPagar: 'Saldo a pagar',
  strSelecionarProjeto: 'Projeto',
  strSelecionarColigada: 'Selecione a coligada',
  strSelectProjeto: 'Selecione o projeto',
  strColigadaProjetoObrigatorios: 'Coligada e Projeto são obrigatórios.',
  strSalvar: 'Salvar',
  strCancelar: 'Cancelar',
  strUsuarioSemPermissaoFuncionalidade: 'Você não tem permissão para acessar o Cockpit de tarefa/insumo na coligada',
  strNenhumRegistroEncontrado: 'Nenhum registro encontrado.',
  strVerificandoPermissao: 'Verificando permissão',
  strVejaMais: 'Veja Mais',
  strPlaceHolderMultiSelectTaskInput: 'Filtrar por grupo de custo',
  strQuantidade: 'Quantidade',
  strValor: 'Valor',
  strUnidade: 'unidade',
  strSaldoInsumo: 'Saldo = Orçado - (Pedido + Contratado)',
  strSaldoInsumoTarefa: 'Saldo = Orçado - (Pedido + Medido)',
  strMedido: 'Medido',
  strOrcado: 'Orçado',
  strApropriado: 'Apropriado',
  strPedido: 'Pedido',
  strPedidos: 'Pedidos',
  strEntregue: 'Entregue',
  strTarefas: 'Tarefas',
  strInsumos: 'Insumos',
  strInputTaskLabelDisclaimer: 'Código ou Descrição de Tarefas',
  strPlanejado: 'Planejado',
  strCusto: 'Custo',
  strConfigHost: 'Necessário a definição do endereço do servidor no arquivo {0}, configuração atual {1}, com essa configuração será possível a utilização do cockpit somente no servidor instalado.',
  strPlaceHolderInputTask: 'Deseja visualizar tarefas específicas? Digite aqui o código, nome, descrição ou partes do código, nome ou descrição.',
  strStatus: 'status',
  strTarefaFinalizada: 'da tarefa finalizada',
  strProjetoAtual: 'Seu projeto atual',
  strUltimaImportacaoBackOffice: 'Última Importação de Movimentações do BackOffice',
  strUltimoCalculoProjeto: 'Último Cálculo do Projeto',
  strUsuario: 'Usuário',
  strTituloTotvs: 'PORTAL TOTVS CONSTRUÇÃO OBRAS & PROJETOS',
  strTrocarProjeto: 'Trocar projeto',
  strSair: 'Sair',
  strPedidoExtra: 'pedido extra',
  strMedicoes: 'medições',
  strAtualizar: 'Atualizar',
  strCodTarefa: 'Cod. Tarefa',
  strNome: 'Nome',
  strDescricao: 'Descrição',
  strPortugues:'Português',
  strEspanhol:'Español',
  strIngles:'English',
  strTarefaNaoEncontrada:'Tarefa não encontrada.'
};

